module.exports = __webpack_public_path__ + "img/Codium-PL-RGB-REV.0fb0da1e.png";